import { ESLCourseData } from "../../data/ESL/ESLCourseData";
import ESLCourseTemplate from "../../pageTemplate/ESLCourseTemplate";
export default function ESLEOPage() {
    return (
        <div>
            <ESLCourseTemplate data={ESLCourseData[2]} />
        </div>
    )
}